/**
 * Extracted from sections/ns-them-vs-us-cards-v2.liquid (inline <script> at line 459).
 * Config bridge: window.__nsThemVsUsCardsV2Sections, keyed by section id. The Liquid the block
 * needed (its section id plus the settings listed in the bridge) is now
 * handed over as data, so the logic can live in a cacheable, deferred
 * asset instead of being parsed and compiled during the HTML parse
 * (INP work on the PDP). Boots once per registered section id.
 */

(function () {
  var cfg = window.__nsThemVsUsCardsV2Sections = window.__nsThemVsUsCardsV2Sections || {};
  function boot(nsSectionId, nsSettings) {
          (function () {
            let tvu2Swiper = null;

            function initTvu2Swiper() {
              const root = document.getElementById(`shopify-section-${nsSectionId}`);
              if (!root) return;

              const swiperEl = root.querySelector('.tvu2__swiper-inner');
              if (!swiperEl) return;
              if (typeof Swiper === 'undefined') return;

              if (tvu2Swiper) {
                tvu2Swiper.destroy(true, true);
                tvu2Swiper = null;
              }

              const prevEl = root.querySelector('.tvu2__prev');
              const nextEl = root.querySelector('.tvu2__next');
              const paginationEl = root.querySelector('.tvu2__pagination');

              const navigationConfig =
                prevEl && nextEl
                  ? {
                      nextEl,
                      prevEl
                    }
                  : false;

              /* Freeze the bullet strip at its resting width.
               *
               * From 541px up the active bullet animates out to the pill width
               * while the outgoing one animates back down, on one curve, so the
               * strip's content width is constant in exact arithmetic. Chrome
               * snaps each used width to 1/64px on its own, though, and the pair
               * does not always land on complementary sixty-fourths — the strip
               * measures up to 0.0156px narrow for a frame. `.tvu2__controls`
               * centres its row, so that deficit landed on the NEXT arrow:
               * measured at 0.0156px of travel per click at 1440 on both
               * founder-story templates.
               *
               * The bullet count is swiper's to decide (slides - slidesPerView +
               * 1, so 12 / 11 / 9 across this section's three breakpoints), which
               * is why the width is measured rather than derived in Liquid. It is
               * re-measured whenever swiper rebuilds or re-lays-out the strip,
               * with the bullet transitions suppressed so a resize arriving
               * mid-animation still reads the resting geometry, and it is
               * published as a custom property the stylesheet consumes with an
               * `auto` fallback — the pre-pin behaviour if this never runs.
               *
               * This does NOT interfere with the mobile no-wrap/shrink fix: the
               * measurement is taken after flex has done its shrinking, so the
               * pinned value IS the shrunk width. */
              const pinPagination = () => {
                if (!paginationEl) return;
                const bullets = [...paginationEl.querySelectorAll('.swiper-pagination-bullet')];
                if (bullets.length < 1) return;
                paginationEl.style.setProperty('--tvu2-pager-w', 'auto');
                bullets.forEach((bullet) => { bullet.style.transition = 'none'; });
                void paginationEl.offsetWidth;
                const width = paginationEl.getBoundingClientRect().width;
                bullets.forEach((bullet) => { bullet.style.transition = ''; });
                if (width > 0) {
                  paginationEl.style.setProperty('--tvu2-pager-w', width.toFixed(3) + 'px');
                } else {
                  paginationEl.style.removeProperty('--tvu2-pager-w');
                }
                void paginationEl.offsetWidth;
              };

              tvu2Swiper = new Swiper(swiperEl, {
                slidesPerView: nsSettings.slidesMobile,
                slidesPerGroup: 1,
                spaceBetween: nsSettings.spaceMobile,
                speed: 600,
                grabCursor: true,
                loop: false,
                watchOverflow: true,
                navigation: navigationConfig,
                pagination: paginationEl
                  ? {
                      el: paginationEl,
                      clickable: true,
                      type: 'bullets'
                    }
                  : false,
                breakpoints: {
                  541: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: nsSettings.spaceTablet
                  },
                  981: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: nsSettings.spaceDesktop
                  }
                },
                /* Re-pin only when the strip's RESTING geometry can have changed:
                 * after the first render, whenever swiper rebuilds the bullets
                 * (init and every breakpoint crossing) and on resize. Deliberately
                 * NOT on slideChange — that fires with the pills mid-flight, which
                 * is the one moment the measurement would be wrong. */
                on: {
                  afterInit: pinPagination,
                  paginationRender: pinPagination,
                  resize: pinPagination
                }
              });
            }

            function waitForSwiper(callback) {
              if (typeof Swiper !== 'undefined') {
                callback();
                return;
              }
              const checkInterval = setInterval(() => {
                if (typeof Swiper !== 'undefined') {
                  clearInterval(checkInterval);
                  callback();
                }
              }, 50);
            }

            waitForSwiper(initTvu2Swiper);

            if (typeof Shopify !== 'undefined' && Shopify.designMode) {
              document.addEventListener('shopify:section:load', function () {
                initTvu2Swiper();
              });
            }
          })();
      
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
